import { Component, type ErrorInfo, type ReactNode } from 'react'

interface AppErrorBoundaryProps {
  readonly children: ReactNode
}

interface AppErrorBoundaryState {
  readonly failed: boolean
}

/** Verhindert eine leere Seite bei unerwarteten Fehlern im React-Baum. */
export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { failed: false }

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Bis ein zentraler Fehlerdienst angebunden ist, bleibt der technische
    // Kontext in der Browser-Konsole für Support und Diagnose erhalten.
    console.error('Unerwarteter Fehler in Weltmaschine Insights.', error, info)
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children

    return (
      <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-900">
        <section className="w-full max-w-lg rounded-lg border border-red-200 bg-white p-6 text-center shadow-sm dark:border-red-900 dark:bg-slate-800">
          <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100">
            Die Oberfläche ist unerwartet abgebrochen
          </h1>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
            Beim Laden dieser Ansicht ist ein technischer Fehler aufgetreten.
          </p>
          <button
            type="button"
            onClick={() => {
              window.location.reload()
            }}
            className="mt-5 rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white dark:bg-slate-100 dark:text-slate-900"
          >
            Seite neu laden
          </button>
        </section>
      </main>
    )
  }
}
